export const EC_SET_UI_FLAG = 'EC_SET_UI_FLAG';
export const EC_SET_CAMPAIGN = 'EC_SET_CAMPAIGN';
export const EC_SET_TASKS = 'EC_SET_TASKS';
export const EC_UPSERT_TASK = 'EC_UPSERT_TASK';
export const EC_REMOVE_TASK = 'EC_REMOVE_TASK';
export const EC_SET_EVENTS = 'EC_SET_EVENTS';
export const EC_UPSERT_EVENT = 'EC_UPSERT_EVENT';
export const EC_REMOVE_EVENT = 'EC_REMOVE_EVENT';
export const EC_SET_SCRIPTS = 'EC_SET_SCRIPTS';
export const EC_SET_WORKERS = 'EC_SET_WORKERS';
export const EC_UPSERT_WORKER = 'EC_UPSERT_WORKER';
export const EC_REMOVE_WORKER = 'EC_REMOVE_WORKER';
export const EC_SET_FIELD_SUMMARY = 'EC_SET_FIELD_SUMMARY';
export const EC_SET_FIELD_BY_CITY = 'EC_SET_FIELD_BY_CITY';
export const EC_SET_FIELD_HIERARCHY = 'EC_SET_FIELD_HIERARCHY';
export const EC_SET_MEDIA_ASSETS = 'EC_SET_MEDIA_ASSETS';
export const EC_UPSERT_MEDIA_ASSET = 'EC_UPSERT_MEDIA_ASSET';
export const EC_REMOVE_MEDIA_ASSET = 'EC_REMOVE_MEDIA_ASSET';
export const EC_SET_MAP = 'EC_SET_MAP';
export const EC_SET_PINS = 'EC_SET_PINS';
export const EC_UPSERT_PIN = 'EC_UPSERT_PIN';
export const EC_REMOVE_PIN = 'EC_REMOVE_PIN';
